/* eslint-disable react-hooks/exhaustive-deps */
import {
  Button,
  Flex,
  Link,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Space,
  Text,
  useColorMode,
  useColorStyle,
  Checkbox,
  Select,
  Option,
  Switch,
} from '@tonic-one/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  FormInput,
  FormLabel,
  FormTextarea,
} from 'src/components/Common/FormComponent';
import { useWhyDidYouUpdate } from 'src/utils/hooks';
import i18next from 'i18next';
import { CAS_DOC_LINK, getCasOLHLink } from '@Utils/casDocLink';
import { ActionEnum, EnableDisableStatus } from '@Policy/utils/types';
import { actionTranslateMap } from './shared';
import { Info } from '@Components/Common/Info';
import useActionNotificationStyle from './style';

const AdvancedSettingsModal = (props: {
  isVisible: boolean;
  onClose: () => void;
  availableTokenShow: boolean;
  config: {
    secondActionEnabled: number;
    secondActionType: number;
    replaceFileTagContent: string;
    replaceText: string;
    replaceTextDefault: string;
    firstActionEnabled?: number;
    firstActionType?: number;
    firstActionNotifyType?: EnableDisableStatus;
  };
  saveConfig: (config: {
    secondActionEnabled: number;
    secondActionType: number;
    replaceFileTagContent: string;
    replaceText: string;
    firstActionEnabled?: number;
    firstActionType?: number;
    firstActionNotifyType?: EnableDisableStatus;
  }) => void;
  isExtraAction?: boolean;
}) => {
  const {
    isVisible,
    onClose,
    availableTokenShow,
    config: {
      secondActionEnabled,
      secondActionType,
      replaceFileTagContent = '',
      replaceText,
      replaceTextDefault,
      firstActionEnabled = 0,
      firstActionType = 251,
      firstActionNotifyType,
    },
    saveConfig,
    isExtraAction = false,
  } = props;
  const { t } = useTranslation();
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const { iconColor } = useActionNotificationStyle();
  const [firstActionEnabledInner, setFirstActionEnabledInner] =
    React.useState<boolean>(firstActionEnabled ? true : false);
  const [firstActionTypeInner, setFirstActionTypeInner] =
    React.useState(firstActionType);
  const [firstActionNotifyTypeInner, setFirstActionNotifyTypeInner] =
    React.useState<boolean>(firstActionNotifyType ? true : false);
  const [secondActionEnabledInner, setSecondActionEnabledInner] =
    React.useState<boolean>(secondActionEnabled ? true : false);
  const [secondActionTypeInner, setSecondActionTypeInner] =
    React.useState(secondActionType);
  const [fileTag, setFileName] = React.useState(replaceFileTagContent);
  const [text, setText] = React.useState(replaceText);
  const onReset = React.useCallback(() => {
    setText(replaceTextDefault);
  }, [replaceTextDefault]);
  const onSave = React.useCallback(() => {
    const config = {
      firstActionEnabled: firstActionEnabledInner ? 1 : 0,
      firstActionType: firstActionTypeInner,
      firstActionNotifyType: firstActionNotifyTypeInner ? 1 : 0,
      secondActionEnabled: secondActionEnabledInner ? 1 : 0,
      secondActionType: secondActionTypeInner,
      replaceFileTagContent: fileTag,
      replaceText: text,
    };
    saveConfig(config);
    onClose();
  }, [
    firstActionEnabledInner,
    firstActionTypeInner,
    firstActionNotifyTypeInner,
    secondActionEnabledInner,
    secondActionTypeInner,
    fileTag,
    text,
  ]);
  const fisrtActions = [
    ActionEnum.pass,
    ActionEnum.tagFileName,
    ActionEnum.delete,
    ActionEnum.quarantine,
  ];
  const secondaryActions = [
    ActionEnum.pass,
    ActionEnum.tagFileName,
    ActionEnum.delete,
  ];
  useWhyDidYouUpdate('AdvancedSettingsModal', {
    ...props,
    text,
    fileName: fileTag,
  });

  return (
    <Modal
      ensureFocus={true}
      autoFocus={false}
      closeOnEsc={true}
      closeOnOutsideClick={false}
      isClosable={true}
      isOpen={isVisible}
      onClose={onClose}
      size="lg"
    >
      <ModalOverlay opacity={0.9} />
      <ModalContent backgroundColor={colorStyle.background.secondary}>
        <ModalHeader></ModalHeader>

        <ModalBody ml="24px" mt="16px" mb="16px">
          <Flex direction="column">
            {isExtraAction && (
              <Flex mb="16px" direction="column">
                <Flex mb="16px" ml="152px" alignItems="center">
                  <Checkbox
                    checked={firstActionEnabledInner}
                    onClick={() => {
                      setFirstActionEnabledInner(!firstActionEnabledInner);
                      setSecondActionEnabledInner(false);
                    }}
                  >
                    {t(
                      'policy.policyTemplate.SFSandbox.tmWebthreatprotections.advancedSettings.label'
                    )}
                  </Checkbox>
                  <Info
                    iconStyle={{ color: iconColor, ml: '1x' }}
                    content={t(
                      'policy.policyTemplate.SFSandbox.tmWebthreatprotections.advancedSettings.tips'
                    )}
                  />
                </Flex>
                <Flex mb="16px">
                  <FormLabel label={t('log.fields.action')} />
                  <Select
                    width="304px"
                    value={firstActionTypeInner}
                    onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                      setFirstActionTypeInner(Number(e.target.value));
                    }}
                  >
                    {fisrtActions.map((item) => {
                      return (
                        <Option value={item}>
                          {t(actionTranslateMap[item])}
                        </Option>
                      );
                    })}
                  </Select>
                </Flex>
                {firstActionNotifyType && (
                  <Flex alignItems="center" mb="12px">
                    <FormLabel label={t('policy.label.notification')} />
                    <Switch
                      checked={!!firstActionNotifyTypeInner}
                      onChange={() => {
                        setFirstActionNotifyTypeInner(
                          !firstActionNotifyTypeInner
                        );
                      }}
                    />
                    <Text ml="8px">
                      {firstActionNotifyTypeInner
                        ? t(`policy.status.on`)
                        : t(`policy.status.off`)}
                    </Text>
                  </Flex>
                )}
              </Flex>
            )}

            <Flex mb="16px" ml="152px">
              <Checkbox
                disabled={firstActionEnabledInner}
                checked={secondActionEnabledInner}
                onClick={() => {
                  setSecondActionEnabledInner(!secondActionEnabledInner);
                }}
              >
                {t(
                  'policy.policyTemplate.SFSandbox.tmVirusscans.advancedSettings.label'
                )}
              </Checkbox>
            </Flex>

            <Flex mb="16px">
              <FormLabel
                label={t(
                  'policy.policyTemplate.SFSandbox.tmVirusscans.advancedSettings.action'
                )}
              />
              <Select
                width="304px"
                disabled={!secondActionEnabledInner}
                value={secondActionTypeInner}
                onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                  setSecondActionTypeInner(Number(e.target.value));
                }}
              >
                {secondaryActions.map((item) => {
                  return (
                    <Option value={item}>{t(actionTranslateMap[item])}</Option>
                  );
                })}
              </Select>
            </Flex>

            <Flex mb="16px">
              <FormLabel
                label={t(
                  'policy.policyTemplate.SFSandbox.tmVirusscans.advancedSettings.filenameTage'
                )}
              />
              <FormInput
                placeholder={t('policy.action.replaceAction.filenameInput')}
                value={fileTag}
                width="600px"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  console.log(e.target.value);
                  setFileName(e.target.value);
                }}
              />
            </Flex>

            <Flex mb="16px">
              <FormLabel label={t('policy.action.replaceAction.text')} />
              <FormTextarea
                value={text}
                width="600px"
                onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
                  setText(e.target.value);
                }}
              />
            </Flex>
            <Flex>
              <FormLabel label="" />
              <Button onClick={() => onReset()}>
                {t('common.label.reset')}
              </Button>
              {availableTokenShow && (
                <Link
                  width="100%"
                  href={getCasOLHLink(
                    CAS_DOC_LINK.policy.atp.tokenList,
                    i18next.language
                  )}
                  target="_blank"
                >
                  <Text
                    ml={12}
                    overflow="hidden"
                    whiteSpace="nowrap"
                    textOverflow="ellipsis"
                  >
                    {t('policy.label.availableTokens')}
                  </Text>
                </Link>
              )}
            </Flex>
          </Flex>
        </ModalBody>
        <ModalFooter>
          <Button variant="primary" minWidth="20x" onClick={onSave}>
            {t('common.button.save')}
          </Button>
          <Space width="2x" />
          <Button minWidth="20x" onClick={onClose}>
            {t('common.button.cancel')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default React.memo(AdvancedSettingsModal);
